import React from 'react';
import MessageBubble from './toolkit-chatbot-panel-message-bubble';
import { DOC_INDEXING_STATUS, MAX_RETRY_COUNT } from './toolkit-chatbot-utils';
import { FormattedMessage } from 'react-intl';
import ErrorNotification from 'components/util/error-notification-component';

const ChatWindow = ({
  BLOCK,
  messages,
  setMessages,
  currentUser,
  containerCode,
  cbFeedbackEnabled,
  isIndexingCompleted,
  geoCode,
  documentIndexingData,
  handleRetryClick,
}) => {
  const renderIndexingMessage = () => {
    if (documentIndexingData?.status === DOC_INDEXING_STATUS.IN_PROGRESS) {
      return (
        <FormattedMessage
          id={'statement-chatbot-indexing-inprogress-message'}
        />
      );
    }

    if (documentIndexingData?.status === DOC_INDEXING_STATUS.PURGED) {
      return (
        <FormattedMessage
          id={'statement-chatbot-purged-message'}
          values={{
            retry: (
              <button
                role="button"
                tabIndex={0}
                onClick={handleRetryClick}
                className={`${BLOCK}__retry-button`}
              >
                <FormattedMessage
                  id={'statement-chatbot-re-index-retry-button'}
                />
              </button>
            ),
          }}
        />
      );
    }

    if (documentIndexingData?.retryCount >= MAX_RETRY_COUNT) {
      return (
        <ErrorNotification errorMessage="statement-chatbot-unavailable-message" />
      );
    }

    return (
      <FormattedMessage
        id={'chatbot-body.indexing.incomplete.message'}
        values={{
          retry: (
            <button
              role="button"
              tabIndex={0}
              onClick={handleRetryClick}
              className={`${BLOCK}__retry-button`}
            >
              <FormattedMessage
                id={'statement-chatbot-re-index-retry-button'}
              />
            </button>
          ),
        }}
      />
    );
  };

  return (
    <>
      {!isIndexingCompleted ? (
        <div className={`${BLOCK}__chat-not-available-message`}>
          {renderIndexingMessage()}
        </div>
      ) : (
        <div className={`${BLOCK}__chat-window`}>
          {messages.map((message) => (
            <MessageBubble
              key={message.id}
              message={message}
              BLOCK={BLOCK}
              setMessages={setMessages}
              currentUser={currentUser}
              containerCode={containerCode}
              cbFeedbackEnabled={cbFeedbackEnabled}
              geoCode={geoCode}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default ChatWindow;
